import { Link, Stack, Typography } from "@mui/material";
import React, { FC, Fragment } from "react";
import { Colors } from "@src/gatsby-theme-material-ui-top-layout/colors-twentyfive";
import { PitBreadcrumb } from "@src/helpers/taxonomy";

interface Props {
  breadcrumbs?: PitBreadcrumb[];
  tight?: boolean;
}

const Breadcrumbs: FC<Props> = ({ breadcrumbs = [], tight = false }) => {
  if (breadcrumbs.length === 0) {
    return;
  }

  return (
    <Stack
      sx={{
        flexGrow: 1,
        gap: tight ? "4px" : "10px",
        flexDirection: "row",
        flexWrap: "wrap",
      }}
    >
      {breadcrumbs?.map((crumb: any, index: number) => {
        return (
          <Fragment key={index}>
            <Link href={`#${crumb.id}`}>
              <Typography
                variant="h3"
                sx={{
                  color: Colors.PrimaryContrast,
                  fontFamily: "Inter",
                  fontSize: "14px !important",
                  fontWeight: 600,
                  opacity: 0.6,
                  letterSpacing: 0,
                  lineHeight: {
                    xs: "16px",
                    lg: "unset",
                  },
                }}
              >
                {crumb.label}
              </Typography>
            </Link>

            {index < breadcrumbs.length - 1 && (
              <Typography
                variant="h3"
                sx={{
                  color: Colors.PrimaryContrast,
                  fontFamily: "Inter",
                  fontSize: "14px !important",
                  fontWeight: 600,
                  opacity: 0.5,
                  letterSpacing: 0,
                  lineHeight: {
                    xs: "16px",
                    lg: "unset",
                  },
                }}
              >
                /
              </Typography>
            )}
          </Fragment>
        );
      })}
    </Stack>
  );
};

export default Breadcrumbs;
